import { Link } from "react-router-dom";

const testimonials = [
  {
    name: "柚子皮皮",
    role: "追更 3 年",
    text: "每天八点准时刷新，今天更新的最新话从来不错过，追更漫画真的不用再挨个网站找了。",
    color: "bg-primary-100 text-primary-600",
  },
  {
    name: "夜班小队长",
    role: "悬疑推理粉",
    text: "分类很全，搜索也方便，想看哪部直接搜就行。更新速度很快，画质也清晰，体验很舒服。",
    color: "bg-accent-100 text-accent-600",
  },
  {
    name: "奶茶三分糖",
    role: "治愈日常党",
    text: "编辑推荐很对我胃口，收藏列表管理方便，每晚追更已经成了我的睡前仪式。",
    color: "bg-secondary-100 text-secondary-700",
  },
];

const faqs = [
  {
    q: "天天漫画网多久更新一次漫画？",
    a: "网站每日更新，热门连载漫画的最新话会在每日上午陆续同步上线，最晚当天晚间更新完毕。进入『今日更新』板块即可查看当天所有新增章节。",
  },
  {
    q: "如何快速找到想看的漫画？",
    a: "你可以在顶部搜索框直接输入漫画名称，也可以进入『漫库』页面，按分类（热血冒险、奇幻仙侠、都市生活等）筛选，或按热度、评分排序浏览。",
  },
  {
    q: "连载中的漫画会不会突然断更？",
    a: "我们会对连载作品持续跟进，若某部作品进入休刊或停更，会在作品详情页标注当前状态，方便你及时了解追更进度，避免长时间等待。",
  },
  {
    q: "漫画内容适合所有年龄段的读者吗？",
    a: "天天漫画网收录了覆盖多种题材的连载作品，从校园青春到悬疑推理应有尽有。建议家长和读者根据作品详情页的题材与标签，选择适合自己阅读的内容。",
  },
];

export default function InfoSections() {
  return (
    <>
      <section className="relative overflow-hidden rounded-none bg-primary-600">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20background%20of%20flowing%20comic%20ink%20and%20colorful%20speech%20bubbles%20in%20orange%20and%20cream%20tones%2C%20creative%20manga%20style%20texture%2C%20soft%20gradient%20lighting%2C%20high%20detail%20digital%20art&width=1600&height=500&seq=cta-2026-x1&orientation=landscape"
          alt="天天漫画网加入追更背景图"
          className="absolute inset-0 h-full w-full object-cover opacity-20"
        />
        <div className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-4 py-14 md:flex-row md:items-center md:px-6">
          <div>
            <h2 className="font-heading text-2xl text-background-50 md:text-3xl">
              追更漫画不迷路，最新话抢先看
            </h2>
            <p className="mt-2 text-sm text-background-100">
              天天漫画网每日更新连载漫画，收藏你喜欢的作品，更新第一时间提醒。
            </p>
          </div>
          <Link
            to="/list"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-book-2-fill"></i>进入漫库
          </Link>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="mb-8">
          <p className="mb-2 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-500 uppercase">
            网站口碑
            <span className="h-px w-6 bg-primary-400" />
          </p>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">追更党们怎么说</h2>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="mb-3 flex gap-0.5 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full ${t.color}`}>
                  <i className="ri-user-fill text-lg"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="bg-background-100 py-14">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <div className="mb-8 text-center">
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-bold tracking-widest text-primary-500 uppercase">
              常见问题
              <span className="h-px w-6 bg-primary-400" />
            </p>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
              你想知道的都在这里
            </h2>
          </div>
          <div className="space-y-3">
            {faqs.map((f) => (
              <details
                key={f.q}
                className="group rounded-lg border border-background-200 bg-background-50 p-5 open:border-primary-300"
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold text-foreground-900">
                  {f.q}
                  <i className="ri-add-line text-lg text-primary-500 transition-transform group-open:rotate-45"></i>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}